import { RadioGroup } from '@aloft/toolkit-sui';

import mapboxgl from 'mapbox-gl';

import MapBox from './MapBox';
import { MAP_LAYERS, MAP_STYLES } from './constants';

const items = Object.values(MAP_STYLES).map((style) => ({
  label: style.name,
  value: style.url,
}));

type Props = {
  mapRef: React.MutableRefObject<MapBox | null>;
  style: string;
  onStyleChange: (nextStyle: string) => void;
};

function StyleRadio({ mapRef, style, onStyleChange }: Props) {
  if (!mapRef) return;
  return (
    <RadioGroup
      size="sm"
      items={items}
      value={style}
      onChange={(nextStyle) => {
        const map = mapRef.current?.getMap();
        if (!map) return;

        const forEachLayer = (text: string, cb: (layer: mapboxgl.Layer) => void) => {
          map.getStyle().layers.forEach((layer) => {
            if (!layer.id.includes(text)) return;

            cb(layer);
          });
        };
        const savedLayers: mapboxgl.Layer[] = [];
        const savedSources: { [key: string]: mapboxgl.Source } = {};
        // we add two custom layers to the map, so when we change styles we need to add them back
        const layerGroups = [MAP_LAYERS.PINS, MAP_LAYERS.SUBJECT];

        layerGroups.forEach((layerGroup) => {
          forEachLayer(layerGroup, (layer) => {
            savedSources[layer.source as string] = map
              .getSource(layer.source as string)
              // @ts-expect-error ignore
              .serialize();
            savedLayers.push(layer);
          });
        });

        map.setStyle(nextStyle);
        onStyleChange(nextStyle);

        setTimeout(() => {
          Object.entries(savedSources).forEach(([id, source]) => {
            // @ts-expect-error ignore
            map.addSource(id, source);
          });

          savedLayers.forEach((layer) => {
            // @ts-expect-error ignore
            map.addLayer(layer);
          });
        }, 1000);
      }}
    />
  );
}

export { StyleRadio };
